import * as React from 'react';
import RPGIcon, { GetRPGIcon } from 'source/app/presentation/Shared/RPGIcon/RPGIcon';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
export function GoalIcon({ iconName }: { iconName: string; }) {
	return (
		<span
			{...Style(`gameIdentityGoalIcon`, {
				position: 'relative',
				top: '1px',
				paddingRight: '6px'
			})}
		>
			<RPGIcon icon={GetRPGIcon(iconName)} />
		</span>
	);
}
